import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  resolveSubmissionModalState: false,
  selectedSubmission: null,
  currentPage: 1,
  fieldErrors: null,
  learnerEmail: '',
};

export const capstoneSubmission = createSlice({
  name: 'capstoneSubmission',
  initialState,
  reducers: {
    setSelectedSubmission: (state, action) => {
      state.selectedSubmission = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setResolveSubmissionModalState: (state, action) => {
      state.resolveSubmissionModalState = action.payload;
    },
    setFieldErrors: (state, action) => {
      state.fieldErrors = action.payload;
    },
    setLearnerEmail: (state, action) => {
      state.learnerEmail = action.payload;
    },
  },
});

export const {
  setCurrentPage,
  setSelectedSubmission,
  setResolveSubmissionModalState,
  setFieldErrors,
  setLearnerEmail,
} = capstoneSubmission.actions;
export default capstoneSubmission.reducer;
